export const english = "english";
export const spanish = "spanish";

export const en = "en";
export const es = "es";



// WEBPACK FOOTER //
// ./src/constants/languages.js